import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CheckedIcon from 'assets/svgs/checkIcon.svg';
import { withTranslation } from 'react-i18next';
import './RostersTabs.scss';

class RostersTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.rosterComplete = this.rosterComplete.bind(this);
  }

  componentDidUpdate() {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }

  rosterComplete(category) {
    return category.regsAssigned === category.regsCount;
  }

  selectExamCategory(e, categStatus) {
    e.currentTarget.scrollIntoView({
      block: 'end',
      inline: 'end',
      behavior: 'smooth',
    });

    this.props.onExamCategoryChange(categStatus.type);
  }

  render() {
    const { locationExamineeCount, selectedExamCategory } = this.props;

    return (
      <div className="roster-tabs">
        <div className="scrollbox">
          <div className="scrollbox-content">
            {locationExamineeCount.map((categStatus) => (
              <React.Fragment key={categStatus.displayOrder}>
                <div
                  id={categStatus.displayOrder}
                  className={`${
                    selectedExamCategory === categStatus.type && 'active-tab'
                  } examinee-category`}
                  onClick={(e) => this.selectExamCategory(e, categStatus)}>
                  {this.rosterComplete(categStatus) && <CheckedIcon className="assigned-roster" />}
                  <div className="tab-content">
                    <p
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-boundary="window"
                      data-bs-content={this.props.t('rosters.tabTooltip')}
                      className={`${
                        this.rosterComplete(categStatus) ? 'roster-complete' : ''
                      } assigned-label`}>
                      {this.props.t('rosters.assignedOfLabel', {
                        assigned: categStatus.regsAssigned,
                        total: categStatus.regsCount,
                      })}
                    </p>
                    <p className="fw-bold category-name">
                      <span>{categStatus.name}</span>
                    </p>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
        <hr />
      </div>
    );
  }
}

export default withTranslation()(RostersTabs);
RostersTabs.propTypes = {
  t: PropTypes.func.isRequired,
};
